

type HeadingSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';

interface HeadingProps {
  size: HeadingSize;
  children: React.ReactNode;
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export default function Heading({ size, children, className = 'text-text-900', as }: HeadingProps) {
  const Component = as || 'h2';
  
  const sizeClasses = {
    xs: 'text-heading/xs',
    sm: 'text-heading/sm',
    md: 'text-heading/md',
    lg: 'text-heading/lg',
    xl: 'text-heading/xl',
    '2xl': 'text-heading/2xl',
    '3xl': 'text-heading/3xl',
    '4xl': 'text-heading/4xl',
    '5xl': 'text-heading/5xl',
  };

  return (
    <Component className={`${sizeClasses[size]} ${className}`}>
      {children}
    </Component>
  );
}
